import { useIntl } from '@/intl'

import { routesSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { space, tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  padding-bottom: ${space('primitives_space_8')}
`

const DateText = styled(Typography)`
  margin-left: ${space('primitives_space_8')};
  color: ${tok('semantics_content_color')};
`
const DateTitle = styled(Typography)`
  color: ${tok('semantics_content_color')};
`

export function DepartureTitle() {
  const {
    outboundRoute,
  } = usePricesSelector(routesSelector)
  const intl = useIntl()

  return (
    <Wrapper>
      <DateTitle $variant="body-l-bold-snug">
        {intl.formatMessage({ id: 'prices_transport_selector_departure_title' })}
      </DateTitle>
      <DateText $variant="body-l-bold-snug">{outboundRoute?.departureDate.fullDate}</DateText>
    </Wrapper>
  )
}

export function ArrivalTitle() {
  const {
    inboundRoute,
  } = usePricesSelector(routesSelector)
  const intl = useIntl()

  const isDepartureAndArrivalDateDifferent
    = inboundRoute?.arrivalDate?.fullDate
      && inboundRoute?.departureDate?.fullDate !== inboundRoute?.arrivalDate?.fullDate

  return (
    <Wrapper>
      <DateTitle $variant="body-l-bold-snug">
        {intl.formatMessage({ id: 'prices_transport_selector_arrival_title' })}
      </DateTitle>
      <DateText $variant="body-l-bold-snug">
        {inboundRoute?.departureDate.fullDate}
        {isDepartureAndArrivalDateDifferent && ` - ${inboundRoute?.arrivalDate.fullDate}`}
      </DateText>
    </Wrapper>
  )
}
